import { CONTROLS_IMAGES } from '../../../constants/image.constant';
import { DEVICE_SEVERITY_WARNING, DEVICE_SEVERITY_ERROR } from '../../../constants/house.constants';
import { icons, SEVERITY_LEVEL } from './device.constant';

export const getSeverityLevel = notify => {
    const severity = !!~notify.indexOf('|') ? notify.split('|') : [notify];
    if (!!~severity.indexOf(DEVICE_SEVERITY_ERROR)) {
        return SEVERITY_LEVEL.ERROR;
    }

    if (!!~severity.indexOf(DEVICE_SEVERITY_WARNING)) {
        return SEVERITY_LEVEL.WARNING;
    }

    return SEVERITY_LEVEL.INFO;
};

// TODO delete this, not used
export const getIconColorBySeverity = notify => {
    const severity = !!~notify.indexOf('|') ? notify.split('|') : [notify];
    if (!!~severity.indexOf(DEVICE_SEVERITY_ERROR)) {
        return '#e83e2e'; //ERROR;
    }

    if (!!~severity.indexOf(DEVICE_SEVERITY_WARNING)) {
        return '#fcb813'; //WARNING;
    }

    return '#8bb762'; //INFO;
};

export const getIconByType = type => {
    const icon = icons[type];
    return icon || CONTROLS_IMAGES.DEFAULT;
};

export const getIcon = (notify, type) => {
    return {
        fill: getIconColorBySeverity(notify),
        Icon: getIconByType(type)
    };
};


// WEBPACK FOOTER //
// ./~/pluton-core/lib/services/core/device/device.helper.js